module.exports = __webpack_public_path__ + "img/page_img1.1462fb24.jpg";